import React from "react";
import style from "../../assets/css/components/Input/InputCheck.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

function InputCheck({ title, icon, onClick, checked }) {
  return (
    <div className={style.item}>
      <label className={style.option}>
        <input
          type="radio"
          name="radio"
          defaultChecked={checked}
          onClick={onClick}
        />
        <p className={style.icon}>
          {icon ? <FontAwesomeIcon icon={icon} /> : title}
        </p>
        <span className={style.checkmark}>
          <FontAwesomeIcon icon={faCheck} />
        </span>
      </label>
      {icon ? <p className={style.title}>{title}</p> : null}
    </div>
  );
}

export default InputCheck;
